import React, {ReactElement} from 'react';
import './elementLoadingSkeleton.scss';

function ElementLoadingSkeleton(): ReactElement {
    return <div className="c-elementSkeleton" aria-hidden="true" data-testid="element-loading-skeleton" />;
}

export default ElementLoadingSkeleton;
